import React from "react";

function Gap() {
  return (
    <div
      style={{ width: "100%", height: "4vh", backgroundColor: "white" }}
    ></div>
  );
}

export default Gap;
